/* Keyboard-safe mobile navigation with Theme Editor mount/unmount support. */
(() => {
  const controllers = new WeakMap();
  function rootsIn(scope) {
    const roots = [];
    if (scope.matches?.('[data-ax-header]')) roots.push(scope);
    roots.push(...(scope.querySelectorAll?.('[data-ax-header]') || []));
    return roots;
  }
  function init(root) {
    if (controllers.has(root)) return;
    const toggle = root.querySelector('#MobileNavToggle');
    const close = root.querySelector('#MobileNavClose');
    const drawer = root.querySelector('#MobileNavDrawer');
    const backdrop = root.querySelector('#MobileNavBackdrop');
    if (!toggle || !close || !drawer || !backdrop) return;
    const abort = new AbortController();
    let previousOverflow = '';
    let isOpen = false;

    function openDrawer() {
      if (isOpen) return;
      isOpen = true;
      previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      drawer.removeAttribute('inert');
      drawer.setAttribute('aria-hidden', 'false');
      backdrop.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
      close.focus();
    }
    function closeDrawer(restoreFocus = true) {
      if (!isOpen) return;
      isOpen = false;
      drawer.setAttribute('inert', '');
      drawer.setAttribute('aria-hidden', 'true');
      backdrop.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = previousOverflow;
      if (restoreFocus) toggle.focus();
    }
    toggle.addEventListener('click', openDrawer, { signal: abort.signal });
    close.addEventListener('click', () => closeDrawer(), { signal: abort.signal });
    backdrop.addEventListener('click', () => closeDrawer(), { signal: abort.signal });
    document.addEventListener('keydown', (event) => {
      if (!isOpen) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        closeDrawer();
        return;
      }
      if (event.key !== 'Tab') return;
      const focusable = [...drawer.querySelectorAll('a[href],button:not([disabled]),summary,[tabindex]:not([tabindex="-1"])')]
        .filter((element) => element.getClientRects().length > 0);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }, { signal: abort.signal });
    controllers.set(root, { abort, closeDrawer });
  }
  function unmount(scope) {
    rootsIn(scope).forEach((root) => {
      const controller = controllers.get(root);
      if (!controller) return;
      controller.closeDrawer(false);
      controller.abort.abort();
      controllers.delete(root);
    });
  }
  const mount = (scope = document) => rootsIn(scope).forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(), { once: true });
  else mount();
  document.addEventListener('shopify:section:load', (event) => mount(event.target));
  document.addEventListener('shopify:section:unload', (event) => unmount(event.target));
})();
